import React from 'react';
import { ChevronDown } from '@gravity-ui/icons';
import { ActionTooltip, Button, Icon, Menu, Popup } from '@gravity-ui/uikit';
import { cn } from '../../classname';
import { groupBy, isFunction } from '../../lodash';
import { useBooleanState } from '../../react-utils/hooks';
import { ToolbarTooltipDelay } from '../../toolbar';
import './ToolbarButtonWithPopupMenu.css';
const b = cn('toolbar-button-with-popup-menu');
export const ToolbarButtonWithPopupMenu = ({ className, focus, onClick, icon, title, menuItems, }) => {
    const buttonRef = React.useRef(null);
    const [open, , hide, toggleOpen] = useBooleanState(false);
    const groups = React.useMemo(() => groupBy(menuItems.map((i) => (Object.assign(Object.assign({}, i), { group: i.group || '' }))), 'group'), [menuItems, groupBy]);
    const someActive = menuItems.some((item) => !item.ignoreActive && item.action.isActive() === true);
    const everyDisabled = menuItems.every((item) => item.action.isEnable() === false);
    const popupOpen = everyDisabled ? false : open;
    const shouldForceHide = open && !popupOpen;
    React.useEffect(() => {
        if (shouldForceHide) {
            hide();
        }
    }, [hide, shouldForceHide]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionTooltip, { disabled: popupOpen, openDelay: ToolbarTooltipDelay.Open, closeDelay: ToolbarTooltipDelay.Close, title: isFunction(title) ? title() : title },
            React.createElement(Button, { size: "m", ref: buttonRef, view: someActive || popupOpen ? 'normal' : 'flat', selected: someActive, disabled: everyDisabled, className: b(null, [className]), onClick: toggleOpen },
                React.createElement(Icon, { data: icon.data, size: icon.size }),
                '',
                React.createElement(Icon, { data: ChevronDown }))),
        React.createElement(Popup, { anchorRef: buttonRef, open: popupOpen, onClose: hide },
            React.createElement(Menu, { size: "l" }, Object.entries(groups).map(([label, items], key) => {
                return (React.createElement(Menu.Group, { label: label, key: key, className: b('menu-group') }, items.map(({ id, icon, iconSize = 16, action, text, iconClassname }) => (React.createElement(Menu.Item, { key: id, icon: React.createElement(Icon, { data: icon, size: iconSize, className: iconClassname }), active: action.isActive(), disabled: !action.isEnable(), onClick: () => {
                        hide();
                        focus();
                        action.run();
                        onClick === null || onClick === void 0 ? void 0 : onClick(id);
                    }, extraProps: { 'aria-label': text } }, text)))));
            })))));
};
